import React from "react";
import styles from "../../styles/home/linkCopied.module.css"
function LinkCopied(){
    return(
        <p className={styles.linkCopied}>link copied</p>
    )
}

export default  React.memo(LinkCopied);